import { useEffect, useState } from 'react';
import CHECKBOX_STATES from '../../../constants/checkBoxTypes';
import { Checkbox } from './CheckBox';

const CheckboxWrapper = (props) => {
  const [checked, setChecked] = useState(props.selected ? CHECKBOX_STATES.Checked : CHECKBOX_STATES.Empty);

  const handleChange = () => {
    props.handleClick(checked);
  };

  useEffect(() => {
    if (props.selected === true && checked !== CHECKBOX_STATES.Checked) {
      setChecked(CHECKBOX_STATES.Checked);
    }
    if (props.selected === false && checked !== CHECKBOX_STATES.Empty) {
      setChecked(CHECKBOX_STATES.Empty);
    }
    if (props.selected === 'Indeterminate' && checked !== CHECKBOX_STATES.Indeterminate) {
      setChecked(CHECKBOX_STATES.Indeterminate);
    }
  }, [props.selected, checked]);

  return (
    <div className='Checkbox-wrapper'>
      <Checkbox label='' disabled={props.disabled} value={checked} onChange={handleChange} />
      {props?.children}
    </div>
  );
};

export default CheckboxWrapper;
